import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled(motion.div)``;

export const Label = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.base[500]};
  font-weight: 700;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
`;
